export var KEYBINDS_MAP = {
  "g h": "Navigate to home",
  "g b": "Navigate to blog posts",
  "g a": "Navigate to appearances",
  "g p": "Navigate to projects",
  "g m": "Navigate to about page",
  "g d": "Navigate to CMS dashboard",
  "Shift+?": "Show keybinds cheatsheet",
  "Meta+KeyK": "Show navigation menu"
};
export function createKeybindsRecord(record) {
  return record;
}